import React from 'react';
import MuiRadio from '@mui/joy/Radio';
import { RadioProps as MuiRadioProps } from '@mui/joy/Radio';

const iconRadioStyles = {
  '--Radio-size': '40px',
  position: 'relative',

  '--variant-outlinedColor': 'var(--casa-palette-neutral-500)',
  '--variant-outlinedBorder': 'var(--casa-palette-neutral-500)',
  '--variant-outlinedBg': 'var(--casa-palette-brand-warmLinen-500)',

  '--variant-outlinedHoverBg': 'var(--casa-palette-neutral-300)',
  '--variant-outlinedHoverColor': 'var(--casa-palette-neutral-500)',
  '--variant-outlinedHoverBorder': 'var(--casa-palette-neutral-500)',
  '--variant-outlinedFocusBg': 'var(--casa-palette-neutral-300)',
  '--variant-outlinedFocusBorder': 'var(--casa-palette-neutral-500)',
  '--variant-outlinedActiveBg': 'var(--casa-palette-neutral-300)',
  '--variant-outlinedActiveColor': 'var(--casa-palette-neutral-500)',
  '--variant-outlinedActiveBorder': 'var(--casa-palette-neutral-500)',
  '--variant-outlinedDisabledBg': 'transparent',
  '--variant-outlinedDisabledColor': 'var(--casa-palette-brand-mono-500)',
  '--variant-outlinedDisabledBorder': 'var(--casa-palette-brand-mono-500)',

  '& .MuiSvgIcon-root': {
    pointerEvents: 'none',
    zIndex: 2,
  },

  '&:not(.Mui-checked):not(.Mui-disabled) svg': {
    fill: 'var(--casa-palette-neutral-500)',
  },
  '& .MuiRadio-action': {},

  '& .MuiRadio-radio': {
    '--variant-borderWidth': '1px',
    position: 'relative',
  },
  '& .MuiRadio-radio:hover': {},
  '& .MuiRadio-radio:focus': {},

  // 修复：选择当前元素（根元素），而不是子元素
  '&.Mui-checked:not(.Mui-disabled)': {
    '& .MuiRadio-radio': {
      borderColor: 'var(--casa-palette-neutral-500)',
      color: 'var(--casa-palette-brand-warmLinen-500)',
      backgroundColor: 'var(--casa-palette-neutral-500)',
      '& svg': {
        fill: 'var(--casa-palette-brand-warmLinen-500)',
      },
    },
  },

  // '&.Mui-disabled:not(.Mui-checked)': {
  //   '& .MuiRadio-radio': {
  //     backgroundColor: 'transparent',
  //     '& svg': {
  //       fill: 'var(--casa-palette-brand-mono-500)',
  //     },
  //   },
  // },
} as const;

export type RadioIconProps = MuiRadioProps;

export const RadioIcon = React.forwardRef<HTMLInputElement, RadioIconProps>((props, ref) => {
  const { sx, ...other } = props;

  return (
    <MuiRadio
      ref={ref}
      sx={{
        ...iconRadioStyles,
        ...sx,
      }}
      {...other}
    />
  );
});
